import React from 'react';
import { RiHeartFill } from 'react-icons/ri';

const Footer = () => {
    return (
        <footer>
            <label>Developed with <RiHeartFill color={'#5F85DB'}/> by <a target="_blank" rel="noopener noreferrer" href="https://github.com/pedro-cabreu">Pedro Abreu</a></label>
        </footer>
    );
}
 
export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.jsx